import { useState } from "react";
import { Offcanvas, Button } from "react-bootstrap";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { AddExtrasJobDetails } from "../../../../../redux/action/client/JobForm";
import ErrorMessage from "../../../../common/ErrorMessage";
import Loader from "../../../../common/Loader";

function AddExtrasSidebar({ match, setReloadElements }) {
  const { jobId } = match.params;
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => {
    setShow(false);
    setError("");
  };
  const handleShow = () => setShow(true);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const dataValue = { job: Number(jobId) };
    const finalResult = Object.assign(data, dataValue);
    dispatch(
      AddExtrasJobDetails(
        finalResult,
        setLoading,
        setError,
        handleClose,
        setReloadElements
      )
    );
    reset();
  };

  return (
    <>
      <div className="my-sm-0 my-2  me-sm-2">
        <Button
          onClick={handleShow}
          className="atech-primary-button  primary-button-padding  w-100"
        >
          Add Extras
        </Button>

        <Offcanvas
          className="Sidebar-width h-100vh "
          show={show}
          placement="end"
          onHide={handleClose}
        >
          <Offcanvas.Body className="d-flex justify-content-center  pt-lg-2">
            <div className="container">
              <Offcanvas.Header
                className="p-0 d-flex justify-content-end pt-2"
                closeButton
              ></Offcanvas.Header>
              <h1 className="dash_head pb-lg-4 pb-3 ">Add Extras</h1>
              <form onSubmit={handleSubmit(onSubmit)}>
                {error !== "" ? <ErrorMessage message={error} /> : ""}
                <div className="row ">
                  <div className="col-12  ">
                    <div className="my-2">
                      <input
                        {...register("males", { required: true })}
                        type="number"
                        className="form-control py-3 atech-input inputs_font_size"
                        placeholder="Males"
                      />
                      {errors.males?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Males is required
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-12 ">
                    <div className="my-2">
                      <input
                        {...register("females", { required: true })}
                        type="number"
                        className="form-control py-3 atech-input inputs_font_size"
                        placeholder="Females"
                      />
                      {errors.females?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Females is required
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-12 ">
                    <div className="my-2">
                      <input
                        {...register("others", { required: true })}
                        type="number"
                        className="form-control py-3 atech-input inputs_font_size"
                        placeholder="Other/s"
                      />
                      {errors.others?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Others is required
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-12 ">
                    <div className="my-2">
                      <input
                        {...register("clothings", { required: true })}
                        type="text"
                        className="form-control py-3 atech-input inputs_font_size"
                        placeholder="Clothing/Makeup"
                      />
                      {errors.clothings?.type === "required" && (
                        <p className="common-text xxs-font text-red">
                          Clothing/Makeup is required
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="my-2">
                  <Form.Group
                    className=" textarea-focus"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Control
                      {...register("details", { required: true })}
                      placeholder="Describe the extras e.g. Patrons of upper class restaurant"
                      as="textarea"
                      rows={5}
                      className="inputs_font_size"
                    />
                    {errors.details?.type === "required" && (
                      <p className="common-text xxs-font text-red">
                        Describe is required
                      </p>
                    )}
                  </Form.Group>
                </div>
                <div className="my-2">
                  <Form.Group
                    className=" textarea-focus"
                    controlId="exampleForm.ControlTextarea1"
                  >
                    <Form.Control
                      {...register("actions", { required: true })}
                      placeholder="Actions: What would you like the extras to do? e.g. Sit and talk/eat in restaurant "
                      as="textarea"
                      rows={5}
                      className="inputs_font_size"
                    />{" "}
                    {errors.actions?.type === "required" && (
                      <p className="common-text xxs-font text-red">
                        Actions is required
                      </p>
                    )}
                  </Form.Group>
                </div>

                <div className="d-flex flex-sm-row  flex-column mt-3">
                  <button
                    className={`${
                      loading ? "cursor-not-allowed" : ""
                    } px-4 atech-primary-button  py-sm-2 py-2 ms-sm-2  my-2`}
                    disabled={loading}
                  >
                    {loading ? <Loader /> : "Save"}
                  </button>
                  <button
                    className="px-4  py-sm-2 py-2 ms-sm-2  my-2  atech-fade-button"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </>
  );
}

export default withRouter(AddExtrasSidebar);
